import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import FctvaPanel from '../panel/FctvaPanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';
import ProjetPanel from '../panel/ProjetPanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';

class ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeSansInfoInv extends BaseProfilEcritureDepense {
	constructor() {
		super();
		this.code =
			PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_INTERIEUR_SECT_INVES_SANS_INFO_INV;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.INVESTISSEMENT;
		this.typePiece = TYPE_PIECE.DEPENSE.ORDRE_BUDGET;
		this.imputation.nature = Nature.ORDRE;
		this.imputation.chapitre = '041';
		this.modeDeReglement = [
			MODE_REGLEMENT.DEPENSE.OPERATION_ORDRE,
			MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE,
		];
		this.defaultModeReglement = MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE;
		this.panels = [
			new FctvaPanel(),
			new SaisieLibrePanel(),
			new ProjetPanel(),
			// TODO : add "Marche public" optional panel
		];
	}
}

export default ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeSansInfoInv;
